/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/no-unknown-property */
/* eslint-disable @scandipwa/scandipwa-guidelines/only-render-in-component */
import { PropTypes } from 'prop-types';
import { PureComponent } from 'react';

import Loader from 'Component/Loader';
import isMobile from 'Util/Mobile/isMobile';

import { HEADER_HEIGHT } from './SubscriptionPreferencs.config';

import './SubscriptionPreferences.style';

/** @namespace Scandipwa/Route/SubscriptionPreferences/Component */
export class SubscriptionPreferencesComponent extends PureComponent {
    static propTypes = {
        iframeUrl: PropTypes.string.isRequired,
        // eslint-disable-next-line react/boolean-prop-naming
        iframeLoading: PropTypes.bool.isRequired,
        closePreferences: PropTypes.func.isRequired
    };

    componentDidUpdate() {
        const iframe = document.getElementById('SubscriptionPreferences');

        if (iframe && isMobile.any()) { // Adding this way since iframe can't be styled using our css
            iframe.style.paddingTop = '10px';
        }
    }

    render() {
        const { iframeUrl, iframeLoading, closePreferences } = this.props;

        return (
            <div block="SubscriptionPreferences">
                <button block="Icon" elem="Close" onClick={ closePreferences } />
                <Loader isLoading={ iframeLoading } />
                <iframe
                  id="SubscriptionPreferences"
                  src={ iframeUrl }
                  height={ window.innerHeight - HEADER_HEIGHT }
                  width={ window.innerWidth }
                />
            </div>
        );
    }
}

export default SubscriptionPreferencesComponent;
